/**
 * It does what the name says
 * @param {object} o
 * @returns {object} clean object
 */
export default function clearObject(o) {
    Object.keys(o).forEach(k => delete o[k]);
    return o;
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/clear-object.js